// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".result-content[data-v-3a2306fd]{padding:0 10px 10px 10px;white-space:pre-line;line-height:24px;max-height:480px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
